import {IPerson} from "../../../../SelectPerson/interface/IPerson";

export const isAPersonSelectable = (personList: IPerson[], activityId: number): IPerson[] =>
  personList.filter((person) =>
    person.activityIds.find((personKnowledge) => personKnowledge === activityId)
  )